import { ReactElement } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { SxProps, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDynamicContext } from '@dynamic-labs/sdk-react-core';

// Assets
import SignupDesktopBg from 'Assets/signup-desktop-bg.png';
import SignupMobileBg from 'Assets/signup-mobile-bg.png';

// Components
import MapleContainer from 'Components/ds/MapleContainer';
import SignupLoginForm from 'Pages/SignupLogin/SignupLoginForm';
import Features from 'Pages/SignupLogin/Features';

// Styles
import { zIndex } from 'Components/ds/MapleTheme/designSystem';

type SignupLoginProps = {
  formType: 'signup' | 'login';
};

const styles: { [key: string]: SxProps } = {
  fullHeight: { minHeight: '100vh' },
  signupLoginForm: { mt: 4, zIndex: zIndex.high },
  featuresWrapper: {
    backgroundImage: { xs: `url(${SignupMobileBg})`, md: 'none' },
    backgroundPositionY: { xs: `bottom`, md: 'center' },
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    flexGrow: 1,
    transform: { xs: 'translateY(-40px)', md: 'translateY(0)' },
    pt: { xs: 2, md: 0 },
  },
  features: { mt: 2 },
  background: {
    height: '100vh',
    width: '50%',
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: -1,
    backgroundImage: `url(${SignupDesktopBg})`,
    backgroundSize: 'cover',
    display: { xs: 'none', md: 'block' },
  },
};

const SignupLogin = ({ formType }: SignupLoginProps): ReactElement => {
  const { breakpoints } = useTheme();
  const isDesktopDevice = useMediaQuery(breakpoints.up('md'));
  const { sdkHasLoaded } = useDynamicContext();

  if (isDesktopDevice)
    return (
      <MapleContainer>
        <Grid container columnSpacing={{ xs: 6, md: 10, lg: 22 }} alignItems='center' sx={styles.fullHeight}>
          <Grid item xs={12} md={6}>
            <SignupLoginForm formType={formType} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.features}>
            {sdkHasLoaded && <Features />}
          </Grid>
          {/* This is the background */}
          <Box sx={styles.background} />
        </Grid>
      </MapleContainer>
    );

  return (
    <Stack sx={styles.fullHeight}>
      <MapleContainer sx={styles.signupLoginForm}>
        <Grid container alignItems='center'>
          <Grid item xs={12}>
            <SignupLoginForm formType={formType} />
          </Grid>
        </Grid>
      </MapleContainer>
      <Box sx={styles.featuresWrapper}>
        <MapleContainer sx={styles.features}>
          <Grid container spacing={{ xs: 6, md: 16 }} alignItems='center'>
            <Grid item xs={12} md={6}>
              <Features />
            </Grid>
          </Grid>
        </MapleContainer>
      </Box>
    </Stack>
  );
};

export default SignupLogin;
